module.exports = function (bootstrap) {
    return bootstrap.getBootstrappedData(bootstrap.bootstrapped.Config) || window.config || {};
};


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/config/config-factory.js
 **/